import { Typography } from 'antd'
import { type ParagraphProps as AntdParagraphProps } from 'antd/lib/typography/Paragraph'
import styles from './styles.module.scss'

interface ParagraphProps extends AntdParagraphProps {
  noMargin?: boolean
}

export function Paragraph({ noMargin, ...props }: ParagraphProps) {
  const classNames = noMargin ? [props.className, styles.noMargin] : [props.className]

  return <Typography.Paragraph {...props} className={classNames.join(' ')} />
}
